
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/team/[id]/[slug]",
      function () {
        return require("private-next-pages/shop/team/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/team/[id]/[slug]"])
      });
    }
  